export default "__VITE_ASSET__N0FTRtnt__"